<div class="text-center">
  <form [formGroup]="adminLoginForm" (ngSubmit)="onSubmit()" class="form-group" vgFocusFirstInvalid [form]="adminLoginForm">
    <h1 class="text-center">Welcome</h1>
    <label for="username">Admin Name</label>
    <input class="form-control" type="text" id="username" placeholder="Admin name" formControlName="username" />
    <vg-error-section
      [label]="'feature.account.username' | translate"
      [group]="adminLoginForm"
      [controlName]="'username'"
    ></vg-error-section>

    <label for="password">Password</label>
    <input class="form-control" type="password" id="password" placeholder="Password" formControlName="password" />
    <vg-error-section
      [label]="'feature.account.password' | translate"
      [group]="adminLoginForm"
      [controlName]="'password'"
    ></vg-error-section>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="dropdownCheck" formControlName="rememberMe" />
      <label class="form-check-label" for="dropdownCheck">Remember Me</label>
    </div>
    <button type="submit" class="btn btn-dark" [disabled]="adminLoginForm.errors">
      <span>{{ 'Sign In' | translate }}</span>
      <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    </button>
  </form>
</div>
